/**
 *  å­æ¾ç³»ç»æ ¸å¿éç½®çå¸¸é
 */

export type UID = string;

export type Timestamp = number;

export enum Is {
    yes = 1,
    no = 0
}

export enum HttpMethods {
    GET = 'GET',

    POST = 'POST',

    PUT = 'PUT',

    DELETE = 'DELETE',

    HEAD = 'HEAD',

    OPTIONS = 'OPTIONS',

    CONNECT = 'CONNECT',

    TRACE = 'TRACE',

    PATCH = 'PATCH'
}

export const EMPTY_OBJECT_ID_STR = `000000000000000000000000`;

export const DEFAULT_PAGE_SIZE = 20;

export const DEFAULT_PAGE_SIZE_LIMIT = 500;

export const ME_UID = '00000000000000000000000000000000';
export const ME = {
    uid: ME_UID,
    display_name: 'æ',
    avatar: ''
};
